import * as React from "react";
import { Tooltip, Dialog, Button, Position, Classes, PreviousNextButton, iconClass, IconNames, } from "@focus/focusUI";
import _ from "lodash";
import { ListContext } from "./ListContext";
import { FocusFormValidator } from "../form/FocusFormValidator";
import { flattenData, FocusFormLockStatusContext, RowContext, } from "../form/utils";
import { useContext } from "react";
import { LockNSaveListButtons } from "./LockNSaveListButtons";
export const ListFormDialog = ({ schema, uiSchema, formData, title, themeName, isOpen, onNext, onPrevious, onCloseWithoutSaving, onChange, onCloseAndSave, openDialog, }) => {
    const { lockStatus, hasInitialValues, handleLock, hidden } = useContext(FocusFormLockStatusContext);
    const handleOpen = () => {
        openDialog();
    };
    const handleChange = (formdata, change) => {
        onChange(formdata, change);
    };
    const isReadOnly = typeof uiSchema["ui:readOnly"] !== "undefined" && uiSchema["ui:readOnly"]
        ? true
        : false;
    const isDisabled = typeof uiSchema["ui:disabled"] !== "undefined" && uiSchema["ui:disabled"]
        ? true
        : false;
    const newUi = React.useMemo(() => _.cloneDeep(uiSchema), [uiSchema]);
    delete newUi["ui:field"];
    return (React.createElement("div", null,
        React.createElement(ListContext.Provider, { value: true },
            React.createElement(RowContext.Provider, { value: {
                    value: flattenData(schema, uiSchema, formData),
                } },
                React.createElement(Tooltip, { content: React.createElement("span", null, "Edit selected row"), position: Position.TOP },
                    React.createElement("button", { type: "button", className: `${Classes.BUTTON} ${iconClass(IconNames.EDIT)} ${Classes.MINIMAL}`, onClick: handleOpen, id: "editRowButton", disabled: typeof formData === "undefined" })),
                React.createElement(Dialog, { className: themeName, icon: "edit", usePortal: true, onClose: onCloseAndSave, title: title, style: { width: "800px" }, isOpen: isOpen },
                    React.createElement("div", { className: Classes.DIALOG_BODY },
                        React.createElement("div", { style: {
                                maxHeight: "60vh",
                                overflowY: "auto",
                                minHeight: "340px",
                            } },
                            React.createElement(FocusFormValidator, { schema: schema, uiSchema: newUi, formData: formData, readOnly: isReadOnly || isDisabled, needsDefaults: true, onChange: handleChange })),
                        React.createElement("div", { style: {
                                textAlign: "center",
                                marginTop: "20px",
                                display: "flex",
                                width: "100%",
                            } },
                            React.createElement("div", { style: {
                                    display: "inline-block",
                                    width: "33%",
                                    textAlign: "left",
                                    verticalAlign: "middle",
                                } },
                                React.createElement(Tooltip, { content: "Click to discard list changes and close", usePortal: false },
                                    React.createElement(Button, { onClick: onCloseWithoutSaving, id: "cancelChangesButton", disabled: isDisabled || isReadOnly }, "Discard"))),
                            React.createElement(PreviousNextButton, { onNextClick: onNext, onPreviousClick: onPrevious, style: { display: "inline-block", width: "33%" } }),
                            React.createElement(LockNSaveListButtons, { containerStyle: {
                                    display: "flex",
                                    width: "33%",
                                    justifyContent: "flex-end",
                                }, disableSaveButton: isDisabled || isReadOnly, hideLockButton: hidden, lockStatus: lockStatus, onLockClick: handleLock, onSaveClick: onCloseAndSave, hasInitialValues: hasInitialValues }))))))));
};
//# sourceMappingURL=ListFormDialog.js.map